import React from "react";
import { useQuery } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import Loader from 'components/general/Loader'
import Referees from 'components/general/Referees'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import TeqScoreboard from "components/sports/teq/views/TeqScoreboard";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TeqContext = () => {
    const { mirs_discipline, mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    //datos para el marcador y estadisticas
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultRSC_H2H,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }

    const resultStatus = data?.results?.status?.code;
    let bodyMiddle
    let score

    if (data?.results) {
        bodyMiddle = <TeqScoreboard data={data} status={resultStatus} mirs_discipline={mirs_discipline} />
    }

    score = <ScoreHorizontal
        data={data}
        scoreBody={{
            top: <></>,
            middle: <>{bodyMiddle}</>
        }}
    />

    return (
        <>
            {data?.results ? (
                <>
                    <PageHeader data={data} />
                    <div className='mirs-page-container'>
                    {/* <div className='my-5'>*/}
                    {score}
                    {/*</div>*/}

                    {data?.results?.officials &&
                        <Referees data={data?.results?.officials} />
                    }
                    </div>
                </>
            ) : (
                <NotAvailable />
            )
            }
        </>
    )







}
export default TeqContext